var _defs, _ellipse, _ellipse2, _path, _path2, _path3, _path4, _path5, _path6, _polygon, _circle, _path7, _path8, _path9, _circle2, _circle3, _circle4, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path10, _path11, _polygon2, _path12, _polygon3, _polyline, _polygon4, _polygon5, _polyline2, _path13, _ellipse7, _path14, _path15, _ellipse8, _path16, _rect, _g, _g2, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLandingModule2 = function SvgLandingModule2(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3945.01 2574.32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f4f5f9;}.cls-2,.cls-7{fill:#f2f2f1;}.cls-10,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-2,.cls-21,.cls-3,.cls-4,.cls-5,.cls-6,.cls-8,.cls-9{stroke:#000;}.cls-10,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-2,.cls-21,.cls-3,.cls-4,.cls-5,.cls-8,.cls-9{stroke-linecap:round;}.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-2,.cls-3,.cls-4,.cls-5,.cls-8,.cls-9{stroke-linejoin:round;}.cls-2{stroke-width:26.38px;}.cls-13,.cls-3,.cls-4,.cls-5,.cls-8{fill:none;}.cls-3,.cls-4,.cls-5{stroke-width:16.74px;}.cls-4{stroke-dasharray:11.4 45.6 11.4 45.6;}.cls-5{stroke-dasharray:11.4 45.6 11.4 45.6 11.4 45.6;}.cls-10,.cls-18,.cls-19,.cls-21,.cls-6{stroke-miterlimit:10;}.cls-6{stroke-width:6.28px;}.cls-10,.cls-18,.cls-8,.cls-9{stroke-width:27.45px;}.cls-10,.cls-12,.cls-21,.cls-9{fill:#fff;}.cls-11{fill:#ececec;}.cls-13{stroke-width:28.54px;}.cls-14,.cls-22{fill:#35b9cc;}.cls-14,.cls-15,.cls-16,.cls-17{stroke-width:13.17px;}.cls-15{fill:#69a8da;}.cls-16{fill:#b5d7ee;}.cls-17{fill:#8abfe6;}.cls-18{fill:#c42f67;}.cls-19{fill:#eb6790;stroke-width:29.87px;}.cls-20{fill:#f3f2f3;}.cls-21{stroke-width:21.3px;}.cls-23{isolation:isolate;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "landing-module2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 745.54,
    cy: 2424.4,
    rx: 678.15,
    ry: 145.21
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 678.15,
    cy: 2429.11,
    rx: 678.15,
    ry: 145.21
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M738.25,803.4",
    transform: "translate(0 0.05)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M920.24,1128.33c-79.6,157-186.67,367.14-207.43,395-31,41.56-106.31,47.43-169.94-84.52-54.44-112.86-104-426.17,80.52-575.48",
    transform: "translate(0 0.05)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M537.15,1002.44q-.6,2.94-1.14,5.83",
    transform: "translate(0 0.05)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M530.18,1053.47c-2.35,38.73,3.83,67.45,16.49,88.34",
    transform: "translate(0 0.05)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M560.82,1159.61c59.75,57.82,194.68,23.16,308.54-3",
    transform: "translate(0 0.05)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M891.59,1151.61l5.8-1.28",
    transform: "translate(0 0.05)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "652.12 1218.39 690.75 1216.44 712.43 1318.74 679.76 1353.44 643.88 1323.62 652.12 1218.39"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 677.04,
    cy: 1308.31,
    r: 13.98
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M995.19,1704.47C912,2162.32,614.77,2178.28,614.77,2178.28L575,2308.13",
    transform: "translate(0 0.05)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1332.52,1004.68c358.46,336.18,591.39-89,591.39-89",
    transform: "translate(0 0.05)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1508.17,913.32s-54.29,452-150.83,1005.87L594.9,1773.33l481-942.71Z",
    transform: "translate(0 0.05)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 1373.85,
    cy: 587.51,
    r: 403.45
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 1270.06,
    cy: 692.6,
    r: 96.71
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 1703.26,
    cy: 682.79,
    r: 42.93
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1413.94,
    cy: 523.62,
    rx: 50.2,
    ry: 87.85,
    transform: "translate(-64.14 225.88) rotate(-8.93)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1595.28,
    cy: 511.78,
    rx: 50.2,
    ry: 87.85,
    transform: "translate(-60.1 253.89) rotate(-8.93)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 1427.55,
    cy: 607.68,
    rx: 50.2,
    ry: 87.85,
    transform: "translate(-77.02 229.02) rotate(-8.93)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 1608.88,
    cy: 595.84,
    rx: 50.2,
    ry: 87.85,
    transform: "translate(-72.99 257.02) rotate(-8.93)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1052.85,1656.1c294.43,422,16.35,822,16.35,822l116.73,1.07",
    transform: "translate(0 0.05)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M628.52,846S897.36,686.24,1033,882.12c15,21.63-84.71,171.51-84.71,171.51s13,66.4-106.43,84.46-164.89,51-236.68,6.85C492.87,1075.89,594.9,871.3,628.52,846Z",
    transform: "translate(0 0.05)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "746.27 939.01 707.99 826 590.98 802.64 512.24 892.3 550.53 1005.32 667.54 1028.67 746.27 939.01"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M545.11,1011.54l8-9.1,117,23.35,38.29,113-20.49,23.32s-52,11.54-93-24.4S545.11,1011.54,545.11,1011.54Z",
    transform: "translate(0 0.05)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "940.71 871.85 902.43 758.83 785.41 735.48 706.68 825.14 744.97 938.15 861.98 961.51 940.71 871.85"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "1029.56 887.38 942.76 870.05 864.03 959.71 902.31 1072.73 929.08 1081.58"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "789.67 736.53 751.38 623.52 634.37 600.16 555.64 689.82 593.92 802.84 710.94 826.19 789.67 736.53"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "385.71 1037.85 337.65 928.64 219.03 915.65 148.48 1011.89 196.54 1121.1 315.16 1134.08 385.71 1037.85"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-17",
    points: "844.21 1134.43 902.11 1068.48 863.83 955.47 746.82 932.11 668.08 1021.77 706.37 1134.79 772.12 1147.91"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M768.16,1152.21l88.65-15.16c7-1.18,4-11.76-2.91-10.58l-88.65,15.15C758.25,1142.81,761.25,1153.39,768.16,1152.21Z",
    transform: "translate(0 0.05)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 1550.8,
    cy: 164,
    rx: 337.4,
    ry: 102.96,
    transform: "translate(36.98 538.5) rotate(-19.93)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1603.87,251.34C1535.11,78.27,1339.05-6.32,1166,62.47S908.34,327.29,977.1,500.36Z",
    transform: "translate(0 0.05)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M493.12,772.24c-12.78,0-25.82,2.19-38.25,5-26.82,6-52.67,17-74.4,34a147.24,147.24,0,0,0-36.83,42.41c-3.54,6.12,5.94,11.65,9.48,5.54,26.34-45.54,77.11-70,127.74-75.14a122.44,122.44,0,0,1,12.26-.77c7.06,0,7.08-11,0-11Z",
    transform: "translate(0 0.05)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    className: "cls-20",
    cx: 2929.7,
    cy: 2407.51,
    rx: 830.37,
    ry: 100.84
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "cls-21",
    d: "M3934.36,687.58V1801.8c-335.3,186.58-670.6,370.53-1005.9,557.11-335.31-186.58-670.61-370.53-1005.94-557.11V687.58c335.3-186.58,670.6-370.53,1005.91-557.11C3263.76,317.05,3599.06,501,3934.36,687.58Z",
    transform: "translate(0 0.05)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-17",
    className: "cls-22",
    x: 2071.94,
    y: 1455.14,
    width: 1727.97,
    height: 283.85,
    rx: 141.92
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Advanced-beginner-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2259,1641.82,2250.5,1614h-42.69l-8.48,27.87h-26.75l41.32-117.55h30.35l41.48,117.55Zm-14.41-48.69q-11.78-37.87-13.25-42.84c-1-3.31-1.7-5.92-2.12-7.85q-2.65,10.26-15.14,50.69Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2326.89,1643.42q-15.78,0-24.78-12.25t-9-34q0-22,9.17-34.32t25.26-12.29q16.89,0,25.79,13.13h.8a99.55,99.55,0,0,1-1.84-17.85v-28.67h24.5v124.6H2358l-4.72-11.61h-1Q2343.94,1643.43,2326.89,1643.42Zm8.57-19.46q9.38,0,13.73-5.44T2354,1600v-2.64q0-14.42-4.45-20.66t-14.45-6.25a14.32,14.32,0,0,0-12.69,6.93q-4.53,6.93-4.53,20.14t4.57,19.82Q2327,1624,2335.46,1624Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2423.62,1641.82l-34.11-89.53h25.55l17.29,51a90.56,90.56,0,0,1,3.61,18.34h.48a79.7,79.7,0,0,1,3.6-18.34l17.22-51h25.54l-34.11,89.53Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2552.47,1641.82l-4.72-12.17h-.64q-6.18,7.77-12.7,10.77t-17,3q-12.9,0-20.3-7.37t-7.41-21q0-14.25,10-21t30.07-7.48l15.53-.48v-3.93q0-13.61-13.93-13.61-10.73,0-25.22,6.49l-8.09-16.5a72.8,72.8,0,0,1,34.27-8.09q18,0,27.63,7.85t9.61,23.86v59.66Zm-7.21-41.48-9.45.32q-10.65.31-15.85,3.84t-5.21,10.73q0,10.33,11.86,10.33,8.47,0,13.57-4.88t5.08-13Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2677.31,1641.82h-24.42v-52.29q0-9.69-3.44-14.53t-11-4.85q-10.24,0-14.81,6.85t-4.56,22.7v42.12h-24.43v-89.53h18.66l3.28,11.45H2618a25.92,25.92,0,0,1,11.26-9.81,38.36,38.36,0,0,1,16.29-3.32q15.61,0,23.7,8.45t8.09,24.38Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2738.81,1643.42q-41.79,0-41.8-45.88,0-22.83,11.37-34.88t32.59-12.05a62.1,62.1,0,0,1,27.87,6.09l-7.21,18.9q-5.76-2.32-10.73-3.81a34.49,34.49,0,0,0-9.93-1.48q-19,0-19,27.07,0,26.26,19,26.26a43.35,43.35,0,0,0,13.06-1.88,47.25,47.25,0,0,0,12-5.88v20.9a39.29,39.29,0,0,1-12,5.2A67.43,67.43,0,0,1,2738.81,1643.42Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2827.3,1643.42q-21.63,0-33.79-11.93t-12.18-33.79q0-22.5,11.25-34.8t31.12-12.29q19,0,29.54,10.81t10.57,29.87v11.85h-57.73q.39,10.41,6.16,16.26t16.18,5.84a67.15,67.15,0,0,0,15.29-1.68,76.68,76.68,0,0,0,15.06-5.36v18.9a57.62,57.62,0,0,1-13.69,4.76A86.48,86.48,0,0,1,2827.3,1643.42Zm-3.44-75.43q-7.77,0-12.18,4.92t-5,14h34.27q-.16-9.06-4.72-14T2823.86,1568Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2912,1643.42q-15.78,0-24.78-12.25t-9-34q0-22,9.17-34.32t25.26-12.29q16.9,0,25.79,13.13h.8a99.55,99.55,0,0,1-1.84-17.85v-28.67h24.5v124.6h-18.74l-4.72-11.61h-1Q2929.07,1643.43,2912,1643.42Zm8.57-19.46q9.38,0,13.73-5.44t4.77-18.5v-2.64q0-14.42-4.45-20.66t-14.45-6.25a14.32,14.32,0,0,0-12.69,6.93q-4.53,6.93-4.53,20.14t4.57,19.82Q2912.1,1624,2920.59,1624Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3079.87,1550.61q15.86,0,24.82,12.37t9,33.92q0,22.17-9.25,34.35t-25.19,12.17q-15.76,0-24.74-11.45h-1.68l-4.09,9.85h-18.65v-124.6h24.42v29q0,5.52-1,17.69h1Q3063,1550.61,3079.87,1550.61Zm-7.85,19.54q-9.06,0-13.22,5.57t-4.32,18.37v2.65q0,14.41,4.28,20.66t13.58,6.24q7.53,0,12-6.92t4.44-20.14q0-13.21-4.48-19.82A14,14,0,0,0,3072,1570.15Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3174.36,1643.42q-21.63,0-33.8-11.93t-12.17-33.79q0-22.5,11.25-34.8t31.11-12.29q19,0,29.55,10.81t10.57,29.87v11.85h-57.73q.39,10.41,6.16,16.26t16.18,5.84a67.15,67.15,0,0,0,15.29-1.68,76.68,76.68,0,0,0,15.06-5.36v18.9a57.54,57.54,0,0,1-13.7,4.76A86.31,86.31,0,0,1,3174.36,1643.42Zm-3.45-75.43q-7.76,0-12.17,4.92t-5,14H3188q-.16-9.06-4.72-14T3170.91,1568Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3308.65,1552.29v12.42l-14,3.6a24.36,24.36,0,0,1,3.85,13.45q0,14.41-10.05,22.46t-27.91,8l-4.4-.24-3.61-.4q-3.77,2.88-3.76,6.41,0,5.28,13.45,5.28h15.22q14.73,0,22.46,6.33t7.73,18.58q0,15.69-13.1,24.34t-37.59,8.65q-18.74,0-28.63-6.53a20.73,20.73,0,0,1-9.89-18.3,19.12,19.12,0,0,1,5-13.53q5-5.44,14.81-7.77a16.27,16.27,0,0,1-6.57-5.24,12.91,12.91,0,0,1,.16-16.26,34.29,34.29,0,0,1,8.57-6.68,24.05,24.05,0,0,1-11.17-9.77,29.74,29.74,0,0,1-4.12-15.86q0-14.65,9.53-22.66t27.22-8a70.33,70.33,0,0,1,8.93.68c3.44.46,5.65.79,6.61,1Zm-69.11,102.18q0,5.05,4.85,7.93t13.57,2.88q13.13,0,20.58-3.6t7.45-9.85a7,7,0,0,0-4.41-7q-4.39-1.92-13.61-1.92h-12.65a19.19,19.19,0,0,0-11.25,3.16A9.76,9.76,0,0,0,3239.54,1654.47Zm8.89-72.87q0,7.29,3.32,11.53t10.13,4.25q6.88,0,10.09-4.25t3.21-11.53q0-16.17-13.3-16.17Q3248.43,1565.43,3248.43,1581.6Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3322.34,1529.15q0-11.93,13.29-11.93t13.3,11.93q0,5.68-3.33,8.85t-10,3.16Q3322.34,1541.16,3322.34,1529.15Zm25.47,112.67h-24.43v-89.53h24.43Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3456.07,1641.82h-24.42v-52.29q0-9.69-3.44-14.53t-11-4.85q-10.24,0-14.81,6.85t-4.56,22.7v42.12h-24.43v-89.53h18.66l3.28,11.45h1.36a25.92,25.92,0,0,1,11.26-9.81,38.36,38.36,0,0,1,16.29-3.32q15.61,0,23.7,8.45t8.09,24.38Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3563.86,1641.82h-24.43v-52.29q0-9.69-3.44-14.53t-11-4.85q-10.24,0-14.81,6.85t-4.57,22.7v42.12h-24.42v-89.53h18.66l3.28,11.45h1.36a25.84,25.84,0,0,1,11.25-9.81,38.41,38.41,0,0,1,16.3-3.32q15.61,0,23.7,8.45t8.09,24.38Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3629.52,1643.42q-21.61,0-33.79-11.93t-12.17-33.79q0-22.5,11.25-34.8t31.11-12.29q19,0,29.55,10.81t10.57,29.87v11.85H3608.3q.4,10.41,6.17,16.26t16.17,5.84a67.3,67.3,0,0,0,15.3-1.68,76.83,76.83,0,0,0,15-5.36v18.9a57.47,57.47,0,0,1-13.69,4.76A86.48,86.48,0,0,1,3629.52,1643.42Zm-3.44-75.43q-7.77,0-12.17,4.92t-5,14h34.27q-.15-9.06-4.72-14T3626.08,1568Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3735.87,1550.61a39.42,39.42,0,0,1,8.24.72l-1.84,22.9a28.15,28.15,0,0,0-7.21-.8q-11.68,0-18.21,6t-6.53,16.82v45.56H3685.9v-89.53h18.49l3.61,15.06h1.2a33.62,33.62,0,0,1,11.25-12.13A27.73,27.73,0,0,1,3735.87,1550.61Z",
    transform: "translate(0 0.05)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Facilitation"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2430.43,1038.38h-18.3V881h87.75v16.26h-69.45v57.6h65.25v16.26h-65.25Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2595.81,1038.38l-3.55-16.8h-.87q-8.82,11.1-17.6,15t-21.91,3.93q-17.55,0-27.51-9t-10-25.73q0-35.75,57.17-37.47l20-.65v-7.32q0-13.89-6-20.51t-19.11-6.62q-14.74,0-33.37,9l-5.49-13.67a84,84,0,0,1,19.11-7.43,82.92,82.92,0,0,1,20.83-2.69q21.11,0,31.28,9.37t10.17,30v80.53Zm-40.38-12.6q16.7,0,26.22-9.15t9.53-25.62V980.35l-17.87.75q-21.33.75-30.74,6.62t-9.42,18.25q0,9.69,5.86,14.75T2555.43,1025.78Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2693,1040.53q-25.62,0-39.67-15.77t-14.05-44.63q0-29.61,14.26-45.76t40.65-16.15a80.73,80.73,0,0,1,17,1.83,56.51,56.51,0,0,1,13.35,4.31l-5.49,15.18a84.12,84.12,0,0,0-12.92-3.93,57.81,57.81,0,0,0-12.38-1.56q-36,0-36,45.87,0,21.75,8.77,33.37t26,11.63a79.46,79.46,0,0,0,30.26-6.35v15.83Q2711,1040.53,2693,1040.53Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2749.34,888.4q0-6.14,3-9a11.17,11.17,0,0,1,15,.05q3.12,2.91,3.12,8.94t-3.12,9a10.4,10.4,0,0,1-7.43,3,10.27,10.27,0,0,1-7.53-3Q2749.35,894.44,2749.34,888.4Zm19.38,150h-17.87v-118h17.87Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2824.49,1038.38h-17.87V870.85h17.87Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2860.88,888.4q0-6.14,3-9a11.17,11.17,0,0,1,15,.05q3.12,2.91,3.13,8.94t-3.13,9a10.4,10.4,0,0,1-7.43,3,10.29,10.29,0,0,1-7.53-3Q2860.89,894.44,2860.88,888.4Zm19.38,150h-17.87v-118h17.87Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2956.27,1025.78a63.68,63.68,0,0,0,16.15-2.15v13.67a32.29,32.29,0,0,1-8.55,2.32,64.27,64.27,0,0,1-10.18.91q-34.23,0-34.24-36.07V934.27h-16.9v-8.62l16.9-7.43L2927,893h10.34v27.35h34.23v13.89h-34.23v69.44q0,10.66,5.06,16.37T2956.27,1025.78Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3068.57,1038.38l-3.55-16.8h-.86q-8.84,11.1-17.61,15t-21.91,3.93q-17.55,0-27.51-9t-10-25.73q0-35.75,57.18-37.47l20-.65v-7.32q0-13.89-6-20.51t-19.11-6.62q-14.76,0-33.38,9l-5.49-13.67a84,84,0,0,1,19.11-7.43,83,83,0,0,1,20.83-2.69q21.1,0,31.28,9.37t10.17,30v80.53Zm-40.37-12.6q16.68,0,26.21-9.15t9.53-25.62V980.35l-17.87.75q-21.32.75-30.74,6.62t-9.42,18.25q0,9.69,5.87,14.75T3028.2,1025.78Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3156.75,1025.78a57.91,57.91,0,0,0,9.15-.7,58.56,58.56,0,0,0,7-1.45v13.67a32.38,32.38,0,0,1-8.56,2.32,64.25,64.25,0,0,1-10.17.91q-34.24,0-34.24-36.07V934.27H3103v-8.62l16.91-7.43,7.53-25.19h10.34v27.35H3172v13.89H3137.8v69.44q0,10.66,5.06,16.37T3156.75,1025.78Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3195,888.4q0-6.14,3-9a11.17,11.17,0,0,1,15,.05q3.12,2.91,3.12,8.94t-3.12,9a10.4,10.4,0,0,1-7.43,3,10.27,10.27,0,0,1-7.53-3Q3195,894.44,3195,888.4Zm19.38,150h-17.87v-118h17.87Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3354.1,979.27q0,28.86-14.53,45.06t-40.16,16.2q-15.82,0-28.1-7.43a49,49,0,0,1-18.95-21.31q-6.68-13.89-6.68-32.52,0-28.85,14.43-44.95t40-16.1q24.77,0,39.35,16.48T3354.1,979.27Zm-89.9,0q0,22.61,9,34.45t26.6,11.85q17.55,0,26.64-11.79t9.1-34.51q0-22.5-9.1-34.18t-26.86-11.68q-17.55,0-26.48,11.52T3264.2,979.27Z",
    transform: "translate(0 0.05)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3466.18,1038.38V962q0-14.41-6.57-21.53t-20.56-7.1q-18.53,0-27.13,10t-8.62,33.05v61.91h-17.87v-118H3400l2.9,16.15h.86a36.51,36.51,0,0,1,15.4-13.51,49.93,49.93,0,0,1,22.07-4.8q21.32,0,32.09,10.29t10.76,32.89v77Z",
    transform: "translate(0 0.05)"
  })))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1270.06,1196.18c214.94,335.81,597.45,27,597.45,27s-5.29-97.67,91.55-88.94",
    transform: "translate(0 0.05)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLandingModule2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/landing-module2.1689cdad262cc0563b96b5d5f0dd71d1.svg";